import {useEffect, useState} from 'react'

import {extractQrTextFromImageUrl} from '#/wsocial/utils/qrCode.ts'

export function useQrDeepLink(qrCodeUrl: string | undefined): string {
  const [signTagUrl, setSignTagUrl] = useState('')

  useEffect(() => {
    if (!qrCodeUrl) {
      setSignTagUrl('')
      return
    }
    let cancelled = false
    extractQrTextFromImageUrl(qrCodeUrl)
      .then(url => {
        if (!cancelled && url) setSignTagUrl(url)
      })
      .catch(() => {})
    return () => {
      cancelled = true
    }
  }, [qrCodeUrl])

  return signTagUrl
}

export function openWIdentityDeepLink(signTagUrl: string) {
  if (!signTagUrl) return
  window.location.href = signTagUrl
}
